import { RouteObject } from 'react-router-dom';
import { RouteMeta } from '@/pages/routes';

const route: RouteObject = {
	path: 'reports',
	loader: () => ({
		meta: {
			title: 'Reports',
			disabled: true,
		} as RouteMeta,
	}),
	lazy: async () => ({ Component: (await import('@/modules/laborLaw/reports/Layout')).default }),
	children: [
		{
			path: 'pnl',
			index: true,
			id: 'laborLawPnlReport',
			loader: () => ({
				meta: {
					title: 'Profit and Loss',
					htmlTitle: 'Labor Law Profit and Loss Report',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/laborLaw/reports/pages/PnL')).default }),
		},
		{
			path: 'mailing',
			index: true,
			id: 'laborLawMailingReport',
			loader: () => ({
				meta: {
					title: 'Mailing',
					htmlTitle: 'Labor Law Mailing Report',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/laborLaw/reports/pages/Mailing')).default }),
		},
		{
			path: 'order',
			index: true,
			id: 'laborLawOrderReport',
			loader: () => ({
				meta: {
					title: 'Order',
					htmlTitle: 'Labor Law Order Report',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/laborLaw/reports/pages/Order')).default }),
		},
		{
			path: 'order/date',
			index: true,
			id: 'laborLawOrderByDateReport',
			loader: () => ({
				meta: {
					title: 'Order By Date',
					htmlTitle: 'Labor Law Order By Date Report',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/laborLaw/reports/pages/OrderByDate')).default }),
		},
	],
};
export default route;
